import { useGame } from '../state/SocketProvider';
import { useTick } from '../util/clock';

/** Connection + own-GPS health. GPS goes stale if the last fix is >15 s old. */
export function ConnPill({ gpsTs, teamed }: { gpsTs: number | null; teamed: boolean }) {
  const { status } = useGame();
  useTick(2000);
  const label =
    status === 'open' ? 'Live' : status === 'reconnecting' ? 'Reconnecting' : status === 'connecting' ? 'Connecting' : 'Offline';
  const dot = status === 'open' ? 'dot--on' : status === 'reconnecting' ? 'dot--warn' : 'dot--signal';

  const gps: 'locked' | 'searching' | 'off' = !teamed ? 'off' : gpsTs && Date.now() - gpsTs < 15_000 ? 'locked' : 'searching';
  return (
    <div className="conn-pill" data-testid="conn-pill">
      <span className={`dot ${dot}`} />
      {label}
      {teamed && (
        <>
          <span style={{ opacity: 0.4 }}>·</span>
          <span className={`dot ${gps === 'locked' ? 'dot--on' : 'dot--warn'}`} />
          GPS
        </>
      )}
    </div>
  );
}
